<template>
  <div :class="['read-more', { expanded: expanded }, 'pb-9']">
    <v-sheet class="read-more-text" :height="expanded ? 'auto' : initialHeight">
      <div class="text-h5 mb-7 font-weight-semibold">
        {{ $t("description") }}
      </div>
      <div class="mb-4" v-for="section in text" :key="section.title">
        <div class="body-2 font-weight-bold text-capitalize">
          {{ section.title }}
        </div>
        <div class="body-2 text-content mt-2" v-html="section.content"></div>
      </div>
    </v-sheet>
    <button
      class="read-more-button text-caption grey--text text--darken-2 text-decoration-underline"
      v-text="expanded ? hideText : readMoreText"
      @click="expanded = !expanded"
    />
  </div>
</template>

<script>
import StylesMixin from "@/mixins/styles-mixin";

export default {
  name: "read-more",
  mixins: [StylesMixin],
  props: {
    text: Array,
    readMoreText: {
      type: String,
      default: "Read more",
    },
    hideText: {
      type: String,
      default: "Hide",
    },
    initialHeight: {
      type: Number,
      default: 200,
    },
  },
  data: () => ({ expanded: false }),
};
</script>

<style lang="scss">
.read-more {
  white-space: pre-line;
  position: relative;
  &.expanded {
    &::after {
      display: none;
    }
  }
  &::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 120px;
    background: linear-gradient(transparent 0%, white 75%);
    bottom: 0;
    z-index: 0;
  }
  &-text {
    position: relative;
    overflow-y: hidden;
  }
  &-button {
    position: absolute;
    color: map-get($cyan, "darken-4");
    cursor: pointer;
    bottom: 6px;
    z-index: 1;
  }
}
.text-content {
  line-height: 1.5rem !important;
  font-weight: 400 !important;
}
</style>
